const basePath = "/user"

const profileRoute = `${basePath}/me`
const subscriptionRoute = `${basePath}/v2/subscriptions`
const installationsRoute = `${basePath}/subscriptions/installations`
const revokeLoginRoute = (userId: number) => `${basePath}/${userId}/revoke`
/** Emails sales that the coach wants an app their team doesn't have. */
const requestAccessRoute = `${basePath}/request-access`
/** Closes the other devices' seats in an app (nobody is signed out). */
const closeOtherSessionsRoute = `${basePath}/team/close-sessions`

export default {
	profileRoute,
	subscriptionRoute,
	installationsRoute,
	revokeLoginRoute,
	requestAccessRoute,
	closeOtherSessionsRoute,
}
